import React, { Fragment } from "react";

import Chip from "@material-ui/core/Chip";
import Grid from '@mui/material/Grid2';
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "left",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
    // padding: 5,
  },
}));

const PostFilter = ({ tags }) => {
  const classes = useStyles();

  let tagsToShow = tags === null ? null : tags.split(",");
  if (tagsToShow !== null) {
    tagsToShow = tagsToShow.filter((tag) => {
      return tag !== "";
    });
  }

  const handleDelete = (tagToDelete) => {
    const updatedTags = tagsToShow.filter((tag) => {
      return tag !== tagToDelete;
    });
    const tagStr = updatedTags.join(",");
    const redirect = tagStr === "" ? "/memory" : `/memory?tags=${tagStr}`;
    window.location.href = redirect;
  };

  const onClearAll = () => {
    window.location.href = "/memory";
  };

  return (
    <Grid xs={12}>
      {tagsToShow !== null ? (
        <Fragment>
          <div className={classes.root}>
            <Typography variant="h6">Filters: </Typography>

            {tagsToShow.length > 1 ? (
              <Chip
                variant="outlined"
                label="Clear All"
                onClick={onClearAll}
                key="clear_all"
              />
            ) : (
              <div />
            )}
            {tagsToShow.map((tag) => (
              <Chip
                variant="outlined"
                label={tag}
                onDelete={() => handleDelete(tag)}
                key={tag}
              />
            ))}
          </div>
        </Fragment>
      ) : (
        <div />
      )}
    </Grid>
  );
};

export default PostFilter;
